export function ExactAddress($scope, businessService, deviceService, popupService, addFormService) {
  'ngInject';

  $scope.isMobile = deviceService.isMobile;

  $scope.isVisible = () => businessService.isCommercialBusinessAvailable();

  $scope.checked = addFormService.getFieldValue('isNeedHideExactAddress', false);
  $scope.onChange = checked => businessService.setExactAddress(checked);

  $scope.title = $scope.isMobile ? 'Скрыть точный адрес объекта' : 'Скрыть точный адрес объекта в объявлении';
  $scope.tooltipText = 'Мы покажем приблизительное расположение:<br/>район и улицу, где находится объект';

  $scope.openHintModal = () => {
    popupService.openPopup('hint', {
      text: $scope.tooltipText,
      title: 'Скрыть точный адрес объекта в объявлении',
      hideCloseButton: false,
    });
  };
}
